<!-- <ngx-spinner name="sp" [fullScreen]="true" type="square-jelly-box" size="medium"></ngx-spinner> -->

<ngx-spinner name="sp" bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#01a8ec" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white">Cargando...</p>
</ngx-spinner>

<router-outlet></router-outlet>
